import { UserContextProvider } from "contexts/HelpAFriend/UserContext";
import { useLanguage, useLocalizedData, useTranslations } from "contexts/LocalizationContext/hooks";
import { ModalContextProvider } from "contexts/ModalContext";
import CustomHead from "modules/common/components/CustomHead";
import PressLogos from "modules/common/components/PressLogos";
import {
  CustomersSay,
  FAQ,
  HelpAFriend as HelpAFriendSection,
  Hero,
  HowItWorks,
} from "modules/help-a-friend/components/sections";
import { MODAL_CLOSE_GTM, MODAL_CLOSE_MP } from "modules/help-a-friend/trackingConsts";
import { Box } from "@chakra-ui/react";
import { stickyBottomBarFirstTriggerStyles } from "components/StickyBottomBar";
import StickyBottomBarTrigger from "components/StickyBottomBar/StickyBottomBarTrigger";
import { useReferralProgramConfig } from "contexts/DataContext/hooks";
import Footer from "modules/common/components/Footer";
import HeaderNav from "modules/common/components/HeaderNav";
import CheckCompensationButton from "modules/common/components/HeaderNav/CheckCompensationButton";
import MenuItems from "modules/common/components/HeaderNav/MenuItems";
import { useTopMenu } from "utils/menuUtils";

const HelpAFriend = ({ noindex }) => {
  const translations = useTranslations();
  const language = useLanguage();
  const topMenu = useTopMenu(language);
  const { getLocalizedCurrency } = useLocalizedData();
  const referralProgramConfig = useReferralProgramConfig();
  const { commissionValue } = referralProgramConfig;

  const topBannerText = translations("promo_bar_get_commission", {
    "%commission%": getLocalizedCurrency(commissionValue, "EUR"),
  });

  return (
    <>
      <CustomHead title={translations("meta_title")} description={translations("meta_description")} noindex={noindex} />
      <HeaderNav
        menuItems={<MenuItems menu={topMenu} />}
        headerButtons={<CheckCompensationButton />}
        topBannerText={topBannerText}
      />
      <UserContextProvider>
        <ModalContextProvider gtmEvent={MODAL_CLOSE_GTM} mixpanelEvent={MODAL_CLOSE_MP}>
          <Box as="main">
            <StickyBottomBarTrigger type="first" styles={stickyBottomBarFirstTriggerStyles} />
            <Hero commissionValue={commissionValue} />
            <HelpAFriendSection />
            <CustomersSay />
            <HowItWorks />
            <FAQ />
            <PressLogos />
          </Box>
        </ModalContextProvider>
      </UserContextProvider>
      <Footer />
    </>
  );
};

export default HelpAFriend;
